import React, { Component } from "react";
import {
  Tabs,
  Card,
  Popconfirm,
  message,
  Button,
  Divider,
  Alert,
  Switch,
} from "antd";
import { connect } from "react-redux";
import storageUtils from "../../utils/storageUtils";

import { formateDate } from "../../utils/dateUtil";
import {
  req_single_slm_accommodation,
  req_edit_slm_survey,
  req_add_slm_survey,
} from "../../api";
import SearchBulletinBoard from "../bulletinBoard/search-bulletinboard";
const { TabPane } = Tabs;

class SurveyStudent extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    loading: false,
    agreePrivacy: true,
    item: {},
    isMyhouse: false,
    isDorm: false,
    isStay: false,
    isContract: false,
    isIntern: false,
    dormRoomCode: "NONE",
    temp: {
      LiveType: "NONE",
      LiveAddress: "",
      LiveCaseNid: -9,
    },
    description: "",
  };

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAgree = this.handleAgree.bind(this);
    this.handleDisagree = this.handleDisagree.bind(this);
    this.handle_ui_switch_process = this.handle_ui_switch_process.bind(this);
  }

  UNSAFE_componentWillMount() {}

  componentDidMount() {
    this.api_single_item();
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_single_item = async () => {
    const { token, userCode } = this.props.user;

    this.setState({ loading: true });
    const result = await req_single_slm_accommodation(userCode, token);
    this.setState({ loading: false });

    const item = result;
    this.setState({ item });
    const { LiveType, LiveAddress, LiveCaseNid } = result;
    const temp = {
      LiveType: LiveType,
      LiveAddress: LiveAddress,
      LiveCaseNid: LiveCaseNid,
    };
    this.setState({ temp });
    //console.log(item)
  };

  api_edit_item = async (item) => {
    const result = await req_edit_slm_survey(
      item,
      storageUtils.getUser().token
    );
    if (result.status === "success") {
      // console.log(result)
      message.success("填報完成");
      this.api_single_item();
    } else {
      message.error(result.message);
    }
  };

  api_add_item = async (item) => {
    const result = await req_add_slm_survey(item, storageUtils.getUser().token);
    if (result.status === "success") {
      // console.log(result)
      message.success("填報完成");
      this.api_single_item();
    } else {
      message.error(result.message);
    }
  };

  ///////////////////////////////////////////////////////////

  handleChange(event) {
    const { item } = this.state;
    //console.log(event)
    Object.keys(item).forEach((propertyName) => {
      if (event.target.id === "agreePrivacy" && event.target.value !== null) {
        // Checkbox
        const agreePrivacy = event.target.checked;
        this.setState({ agreePrivacy });
      } else {
        if (event.target.id === propertyName && event.target.value !== null) {
          item[propertyName] = event.target.value.trim();
        }
      }
    });
    this.setState({ item });
  }

  handleSubmit(event) {
    event.preventDefault();
    const row = this.state.item;
    const temp = this.state.temp;
    const errors = [];

    // 1.數據檢核
    if (row.LiveType.trim() === "NONE") {
      errors.push("未選擇賃居狀況");
    }
    if (row.LiveType === "CONTRACT") {
      if (!row.LiveAddress.trim()) {
        errors.push("地址未填");
      }
      if (!row.HouseOwnerName.trim()) {
        errors.push("出租者姓名未填");
      }
      if (!row.HouseOwnerPhone.trim()) {
        errors.push("出租者電話未填");
      }
    }
    if (row.LiveType === "DORM") {
      if (!row.BuildingName.trim()) {
        errors.push("您未選取所住之宿舍");
      }
    }

    if (errors.length === 0) {
      //console.log(row)
      // 2.數據整理
      if (row.LiveType === "DORM") {
        // row.BuildingName = ''
        row.LiveAddress = this.switch_dormRoom_tag("ADDRESS", row.BuildingName);
        row.HouseOwnerName = "南應大";
        row.HouseOwnerPhone = this.switch_dormRoom_tag("TEL", row.BuildingName);
        row.StudentDescription = "";
      } else if (row.LiveType === "CONTRACT") {
        row.BuildingName = "";
        // row.LiveAddress = ''
        // row.HouseOwnerName = ''
        // row.HouseOwnerPhone = ''
        row.StudentDescription = "";
      } else if (row.LiveType === "MYHOUSE") {
        row.BuildingName = "";
        row.LiveAddress =
          row.MailingAddress === "" ? row.ResidentAddress : row.MailingAddress;
        row.HouseOwnerName = "";
        row.HouseOwnerPhone = "";
        row.StudentDescription = "";
      } else if (row.LiveType === "STAY") {
        row.BuildingName = "";
        // row.LiveAddress = ''
        // row.HouseOwnerName = ''
        // row.HouseOwnerPhone = ''
        // row.StudentDescription = ''
      } else if (row.LiveType === "INTERN") {
        row.BuildingName = "";
        // row.LiveAddress = ''
        // row.HouseOwnerName = ''
        // row.HouseOwnerPhone = ''
        // row.StudentDescription = ''
      }

      if (row.LiveType !== temp.LiveType) {
        // 只要變更賃居狀態[新建survey/再更新student_live]
        this.api_add_item(row);
      } else if (
        row.LiveType === temp.LiveType &&
        row.LiveType === "CONTRACT" &&
        row.LiveAddress.trim() !== temp.LiveAddress.trim()
      ) {
        // 一樣是租屋，但變更了地址[新建survey/再更新student_live]
        this.api_add_item(row);
      } else if (
        row.LiveType === temp.LiveType &&
        row.LiveType === "INTERN" &&
        row.LiveAddress.trim() !== temp.LiveAddress.trim()
      ) {
        // 20241105 增加實習
        // 一樣是租屋，但變更了地址[新建survey/再更新student_live]
        this.api_add_item(row);
      } else if (row.LiveType === temp.LiveType) {
        // 其餘皆[更新survey/再更新student_live]
        row.condition = "STUDENT_BASE_BYID";
        this.api_edit_item(row);
      }
    } else {
      let info = errors.join(",");
      message.error(info);
    }
  }

  handleAgree() {
    const agreePrivacy = true;
    this.setState({ agreePrivacy });
  }

  handleDisagree() {
    const agreePrivacy = false;
    this.setState({ agreePrivacy });
  }

  switch_dormRoom_tag(type, param) {
    if (type === "TEL") {
      switch (param) {
        case "":
          return "062532106";
        case "馨園宿舍":
          return "062546366";
        case "紅樓宿舍":
          return "062531711";
        case "碧苑宿舍":
          return "062531724";
        case "皇御雅宿":
          return "062436520";
        default:
          return "062532106";
      }
    } else {
      switch (param) {
        case "":
          return "台南市永康區中正路529號";
        case "馨園宿舍":
          return "台南市永康區正南五街269號";
        case "紅樓宿舍":
          return "台南市永康區中正路529號";
        case "碧苑宿舍":
          return "台南市永康區中正路529號";
        case "皇御雅宿":
          return "台南市永康區中正七街23號";
        default:
          return "台南市永康區中正路529號";
      }
    }
  }

  handle_ui_switch_process(field, e) {
    const item = this.state.item;
    const value = e === false ? 1 : 0;
    switch (field) {
      case "SA01":
        item.SA01 = value;
        break;
      case "SA02":
        item.SA02 = value;
        break;
      case "SA03":
        item.SA03 = value;
        break;
      case "SA04":
        item.SA04 = value;
        break;
      case "SA05":
        item.SA05 = value;
        break;
      case "SA06":
        item.SA06 = value;
        break;
      case "SA07":
        item.SA07 = value;
        break;
      case "SB08":
        item.SB08 = value;
        break;
      case "SB09":
        item.SB09 = value;
        break;
      case "SB10":
        item.SB10 = value;
        break;
      case "SB11":
        item.SB11 = value;
        break;       
      case "SC11":
        item.SC11 = value;
        break;
      case "SC12":
        item.SC12 = value;
        break;
      case "SC13":
        item.SC13 = value;
        break;
      case "SC14":
        item.SC14 = value;
        break;
      case "SD01":
        item.SD01 = value;
        break;
      default:
    }
    this.setState({ item });

    console.log(item);
  }

  /////////////////////////////
  render() {
    // console.log('render')
    // const formItemLayout = {
    //     labelCol: { span: 4 },
    //     wrapperCol: { span: 18 }
    // }
    const { agreePrivacy } = this.state;
    const {
      LiveType,
      BuildingName,
      LiveAddress,
      HouseOwnerName,
      HouseOwnerPhone,
      LiveCaseReplyDateTime,
      StudentDescription,
      SA01,
      SA02,
      SA03,
      SA04,
      SA05,
      SA06,
      SA07,
      SB08,
      SB09,
      SB10,
      SB11,
      SC11,
      SC12,
      SC13,
      SC14,
      SD01,
    } = this.state.item;
    return (
      <form onSubmit={this.handleSubmit}>
        <Tabs defaultActiveKey="1">
          <TabPane tab="賃居調查" key="1">
            <Card>
              <div className="form-row">
                <div className="form-group form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    name="agreePrivacy"
                    id="agreePrivacy"
                    checked={agreePrivacy}
                    onChange={this.handleChange}
                  />
                  <label className="form-check-label">
                    <Popconfirm
                      title="因應個人資料保護法及本校個人資料管理規定，本校在向您蒐集個人資料之前，依法向您告知下列事項，當您勾選「我同意」，表示您已閱讀、瞭解並同意接受本同意書之所有內容：
                                    一、蒐集目的及類別
                                    為提供活動各項通知服務、報名資料確認、寄送本校或產業相關活動訊息及本校內部管理使用之蒐集目的，而須獲取您下列個人資料類別： 姓名、電話、E-mail 或其他得以直接或間接識別您個人之資料。
                                    二、個人資料利用之期間、地區、對象及方式
                                    您的個人資料，除涉及國際業務或活動外，僅供本校及活動協辦單位於中華民國領域，於上述蒐集目的之必要合理範圍內加以利用至前述蒐集目的消失時為止。
                                    
                                    三、當事人權利行使
                                    依據個人資料保護法第3條規定，您可向本校請求查詢或閱覽、製給複製本、補充或更正、停止蒐集/處理/利用或刪除您的個人資料。
                                    
                                    四、不提供個人資料之權益影響
                                    如您不提供或未提供正確之個人資料，或要求停止蒐集/處理/利用/刪除個人資料、服務訊息的取消訂閱，本校將無法為您提供蒐集目的之相關服務。
                                    
                                    五、各項通知服務、相關訊息之停止寄送，或違反本個資聲明之行為。您可於上班時間聯繫承辦人電話反映。
                                     
                                    個人資料同意提供：
                                    一、本人確已閱讀並瞭解上述告知事項，並勾選「我同意」授權貴校於所列目的之必要合理範圍內，蒐集、處理及利用本人之個人資料。
                                    二、本人瞭解此同意書符合個人資料保護法及相關法規之要求，並提供予貴校留存及日後查證使用。"
                      okText="同意"
                      cancelText="不同意"
                      onConfirm={this.handleAgree}
                      onCancel={this.handleDisagree}
                    >
                      <Button type="link">
                        同意蒐集個人資料告知事項暨個人資料提供
                      </Button>
                    </Popconfirm>
                  </label>
                </div>
              </div>
              <div className="form-row">
                <div className="col-lg">
                  <div className="form-group">
                    <label>
                      <span className="text-danger ">*</span>賃居狀況
                    </label>
                    <select
                      name="LiveType"
                      id="LiveType"
                      className="custom-select mb-3 text-success"
                      defaultValue={LiveType}
                      onChange={this.handleChange}
                      key={LiveType}
                    >
                      <option value="NONE">請選擇</option>
                      <option value="CONTRACT">校外租屋</option>
                      <option value="DORM">校內宿舍</option>
                      <option value="MYHOUSE">自家住宅</option>
                      <option value="STAY">親友住宅(無契約關係)</option>
                      <option value="INTERN">校外實習</option>
                    </select>
                  </div>
                </div>
              </div>
              {LiveType === "DORM" ? (
                <div className="form-row">
                  <div className="col-lg">
                    <div className="form-group">
                      <label>
                        <span className="text-danger ">*</span>宿舍名稱
                      </label>
                      <select
                        name="BuildingName"
                        id="BuildingName"
                        className="custom-select mb-3 text-success"
                        defaultValue={BuildingName}
                        onChange={this.handleChange}
                        key={BuildingName}
                      >
                        <option value="">請選擇</option>
                        <option value="馨園宿舍">馨園宿舍</option>
                        <option value="紅樓宿舍">紅樓宿舍</option>
                        <option value="碧苑宿舍">碧苑宿舍</option>
                        <option value="皇御雅宿">皇御雅宿</option>
                      </select>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
              {LiveType === "CONTRACT" ? (
                <>
                  <div className="form-row">
                    <div className="col-lg">
                      <div className="form-group">
                        <label>賃居地址</label>
                        <input
                          type="text"
                          className="form-control text-primary"
                          name="LiveAddress"
                          id="LiveAddress"
                          aria-describedby="mobileHelp"
                          placeholder="請輸入您目前賃居地址"
                          defaultValue={LiveAddress}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label>出租者姓名</label>
                        <input
                          type="text"
                          className="form-control text-primary"
                          name="HouseOwnerName"
                          id="HouseOwnerName"
                          aria-describedby="mobileHelp"
                          placeholder="請輸入出租者姓名"
                          defaultValue={HouseOwnerName}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label>出租者電話</label>
                        <input
                          type="text"
                          className="form-control text-primary"
                          name="HouseOwnerPhone"
                          id="HouseOwnerPhone"
                          aria-describedby="mobileHelp"
                          placeholder="請輸入出租者電話"
                          defaultValue={HouseOwnerPhone}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="col-lg">
                      <div className="form-group">
                        <Alert
                          message="請您自主檢核以下項目"
                          type="warning"
                          showIcon
                        />
                        <Divider orientation="left" plain>
                          A.安全項目
                        </Divider>
                        <Switch
                          checkedChildren="非採用木造隔間套房(雅房)或鐵皮加蓋"
                          unCheckedChildren="採用木造隔間套房(雅房)或鐵皮加蓋"
                          defaultChecked={SA01 === 0 ? true : false}
                          onChange={(e) =>
                            this.handle_ui_switch_process("SA01", e)
                          }
                        />
                        <Switch
                          checkedChildren="未將多種電器同時插在同一條延長線上"
                          unCheckedChildren="將多種電器同時插在同一條延長線上"
                          defaultChecked={SA02 === 0 ? true : false}
                          onChange={(e) =>
                            this.handle_ui_switch_process("SA02", e)
                          }
                        />
                        <Switch
                          checkedChildren="房間內有裝設火警自動警報器(偵煙器)"
                          unCheckedChildren="房間內未裝設火警自動警報器(偵煙器)"
                          defaultChecked={SA03 === 0 ? true : false}
                          onChange={(e) =>
                            this.handle_ui_switch_process("SA03", e)
                          }
                        />
                        <Switch
                          checkedChildren="有設置滅火器指針在綠色區(或效期三年)"
                          unCheckedChildren="未設置滅火器指針在綠色區(或效期三年)"
                          defaultChecked={SA04 === 0 ? true : false}
                          onChange={(e) =>
                            this.handle_ui_switch_process("SA04", e)
                          }
                        />
                        <Switch
                          checkedChildren="逃生通道(標示)暢通(清楚)且達75cm"
                          unCheckedChildren="逃生通道(未標示)暢通(不清楚)或未達75cm"
                          defaultChecked={SA05 === 0 ? true : false}
                          onChange={(e) =>
                            this.handle_ui_switch_process("SA05", e)
                          }
                        />
                        <Switch
                          checkedChildren="有設置電熱水器或強制排氣瓦斯熱水器"
                          unCheckedChildren="未設置電熱水器或強制排氣瓦斯熱水器"
                          defaultChecked={SA06 === 0 ? true : false}
                          onChange={(e) =>
                            this.handle_ui_switch_process("SA06", e)
                          }
                        />
                        <Switch
                          checkedChildren="建築物具有鎖具或門禁管理措施"
                          unCheckedChildren="建築物不具有鎖具或門禁管理措施"
                          defaultChecked={SA07 === 0 ? true : false}
                          onChange={(e) =>
                            this.handle_ui_switch_process("SA07", e)
                          }
                        />
                        <Divider orientation="left" plain>
                          B.輔助項目
                        </Divider>
                        <Switch
                          checkedChildren="為大型租賃處且辦理公安申報效期2年（或4年）"
                          unCheckedChildren="為大型租賃處但未辦理公安申報效期2年（或4年）"
                          defaultChecked={SB08 === 0 ? true : false}
                          onChange={(e) =>
                            this.handle_ui_switch_process("SB08", e)
                          }
                        />
                        <Switch
                          checkedChildren="建築物內或周邊有裝設監視器設備"
                          unCheckedChildren="建築物內或周邊未裝設監視器設備"
                          defaultChecked={SB09 === 0 ? true : false}
                          onChange={(e) =>
                            this.handle_ui_switch_process("SB09", e)
                          }
                        />
                        <Switch
                          checkedChildren="停車場所明亮安全"
                          unCheckedChildren="停車場所暗黑不安全"
                          defaultChecked={SB10 === 0 ? true : false}
                          onChange={(e) =>
                            this.handle_ui_switch_process("SB10", e)
                          }
                        />
                        <Switch
                          checkedChildren="通勤上下學路線安全"
                          unCheckedChildren="通勤上下學路線不安全"
                          defaultChecked={SB11 === 0 ? true : false}
                          onChange={(e) =>
                            this.handle_ui_switch_process("SB11", e)
                          }
                          disabled={true}
                        />
                        <Divider orientation="left" plain>
                          C.宣導項目
                        </Divider>
                        <Switch
                          checkedChildren="瞭解用電安全常識"
                          unCheckedChildren="不瞭解用電安全常識"
                          defaultChecked={SC11 === 0 ? true : false}
                          onChange={(e) =>
                            this.handle_ui_switch_process("SC11", e)
                          }
                        />
                        <Switch
                          checkedChildren="熟稔住所逃生通道及逃生要領"
                          unCheckedChildren="不熟稔住所逃生通道及逃生要領"
                          defaultChecked={SC12 === 0 ? true : false}
                          onChange={(e) =>
                            this.handle_ui_switch_process("SC12", e)
                          }
                        />
                        <Switch
                          checkedChildren="知悉使用內政部最新『住宅租賃契約書』"
                          unCheckedChildren="不知使用內政部最新『住宅租賃契約書』"
                          defaultChecked={SC13 === 0 ? true : false}
                          onChange={(e) =>
                            this.handle_ui_switch_process("SC13", e)
                          }
                        />
                        <Switch
                          checkedChildren="知悉鄰近派出所、消防隊、醫療院所及學校校安專線聯繫電話"
                          unCheckedChildren="不知悉鄰近派出所、消防隊、醫療院所及學校校安專線聯繫電話"
                          defaultChecked={SC14 === 0 ? true : false}
                          onChange={(e) =>
                            this.handle_ui_switch_process("SC14", e)
                          }
                        />
                        <Divider orientation="left" plain>
                          D.申請項目
                        </Divider>
                        <Switch
                          checkedChildren="申請政府租金補貼"
                          unCheckedChildren="未申請政府租金補貼"
                          defaultChecked={SD01 === 0 ? true : false}
                          onChange={(e) =>
                            this.handle_ui_switch_process("SD01", e)
                          }
                          // disabled={true}
                        />
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
              {LiveType === "STAY" ? (
                <>
                  <div className="form-row">
                    <div className="col-lg">
                      <div className="form-group">
                        <label>親友地址</label>
                        <input
                          type="text"
                          className="form-control text-primary"
                          name="LiveAddress"
                          id="LiveAddress"
                          aria-describedby="mobileHelp"
                          placeholder="請輸入您目前居住地址"
                          defaultValue={LiveAddress}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="col-lg-3">
                      <div className="form-group">
                        <label>親友姓名</label>
                        <input
                          type="text"
                          className="form-control text-primary"
                          name="HouseOwnerName"
                          id="HouseOwnerName"
                          aria-describedby="mobileHelp"
                          placeholder="請輸入親友姓名"
                          defaultValue={HouseOwnerName}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="form-group">
                        <label>親友電話</label>
                        <input
                          type="text"
                          className="form-control text-primary"
                          name="HouseOwnerPhone"
                          id="HouseOwnerPhone"
                          aria-describedby="mobileHelp"
                          placeholder="請輸入親友電話"
                          defaultValue={HouseOwnerPhone}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label>概述關係</label>
                        <input
                          type="text"
                          className="form-control text-primary"
                          name="StudentDescription"
                          id="StudentDescription"
                          aria-describedby="mobileHelp"
                          placeholder="請概述與親友關係"
                          defaultValue={StudentDescription}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
              {LiveType === "INTERN" ? (
                <>
                  <div className="form-row">
                    <div className="col-lg">
                      <div className="form-group">
                        <label>居住地址</label>
                        <input
                          type="text"
                          className="form-control text-primary"
                          name="LiveAddress"
                          id="LiveAddress"
                          aria-describedby="mobileHelp"
                          placeholder="請輸入您居住地址"
                          defaultValue={LiveAddress}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="col-lg-3">
                      <div className="form-group">
                        <label>屋主姓名</label>
                        <input
                          type="text"
                          className="form-control text-primary"
                          name="HouseOwnerName"
                          id="HouseOwnerName"
                          aria-describedby="mobileHelp"
                          placeholder="請輸入屋主姓名"
                          defaultValue={HouseOwnerName}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="form-group">
                        <label>屋主聯絡電話</label>
                        <input
                          type="text"
                          className="form-control text-primary"
                          name="HouseOwnerPhone"
                          id="HouseOwnerPhone"
                          aria-describedby="mobileHelp"
                          placeholder="請輸入屋主聯絡電話"
                          defaultValue={HouseOwnerPhone}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label>與屋主關係</label>
                        <select
                          name="StudentDescription"
                          id="StudentDescription"
                          className="custom-select mb-3 text-success"
                          defaultValue={StudentDescription}
                          onChange={this.handleChange}
                          key={StudentDescription}
                        >
                          <option value="">請選擇</option>
                          <option value="房東租客">房東租客</option>
                          <option value="家人親友">家人親友</option>
                          <option value="實習供宿">實習供宿</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="col-lg">
                      <div className="form-group">
                        <Alert
                          message="請您自主檢核以下項目"
                          type="warning"
                          showIcon
                        />
                        <Divider orientation="left" plain>
                          A.安全項目
                        </Divider>
                        <Switch
                          checkedChildren="非採用木造隔間套房(雅房)或鐵皮加蓋"
                          unCheckedChildren="採用木造隔間套房(雅房)或鐵皮加蓋"
                          defaultChecked={SA01 === 0 ? true : false}
                          onChange={(e) =>
                            this.handle_ui_switch_process("SA01", e)
                          }
                        />
                        <Switch
                          checkedChildren="未將多種電器同時插在同一條延長線上"
                          unCheckedChildren="將多種電器同時插在同一條延長線上"
                          defaultChecked={SA02 === 0 ? true : false}
                          onChange={(e) =>
                            this.handle_ui_switch_process("SA02", e)
                          }
                        />
                        <Switch
                          checkedChildren="房間內有裝設火警自動警報器(偵煙器)"
                          unCheckedChildren="房間內未裝設火警自動警報器(偵煙器)"
                          defaultChecked={SA03 === 0 ? true : false}
                          onChange={(e) =>
                            this.handle_ui_switch_process("SA03", e)
                          }
                        />
                        <Switch
                          checkedChildren="有設置滅火器指針在綠色區(或效期三年)"
                          unCheckedChildren="未設置滅火器指針在綠色區(或效期三年)"
                          defaultChecked={SA04 === 0 ? true : false}
                          onChange={(e) =>
                            this.handle_ui_switch_process("SA04", e)
                          }
                        />
                        <Switch
                          checkedChildren="逃生通道(標示)暢通(清楚)且達75cm"
                          unCheckedChildren="逃生通道(未標示)暢通(不清楚)或未達75cm"
                          defaultChecked={SA05 === 0 ? true : false}
                          onChange={(e) =>
                            this.handle_ui_switch_process("SA05", e)
                          }
                        />
                        <Switch
                          checkedChildren="有設置電熱水器或強制排氣瓦斯熱水器"
                          unCheckedChildren="未設置電熱水器或強制排氣瓦斯熱水器"
                          defaultChecked={SA06 === 0 ? true : false}
                          onChange={(e) =>
                            this.handle_ui_switch_process("SA06", e)
                          }
                        />
                        <Switch
                          checkedChildren="建築物具有鎖具或門禁管理措施"
                          unCheckedChildren="建築物不具有鎖具或門禁管理措施"
                          defaultChecked={SA07 === 0 ? true : false}
                          onChange={(e) =>
                            this.handle_ui_switch_process("SA07", e)
                          }
                        />
                        <Divider orientation="left" plain>
                          B.輔助項目
                        </Divider>
                        <Switch
                          checkedChildren="為大型租賃處且辦理公安申報效期2年（或4年）"
                          unCheckedChildren="為大型租賃處但未辦理公安申報效期2年（或4年）"
                          defaultChecked={SB08 === 0 ? true : false}
                          onChange={(e) =>
                            this.handle_ui_switch_process("SB08", e)
                          }
                        />
                        <Switch
                          checkedChildren="建築物內或周邊有裝設監視器設備"
                          unCheckedChildren="建築物內或周邊未裝設監視器設備"
                          defaultChecked={SB09 === 0 ? true : false}
                          onChange={(e) =>
                            this.handle_ui_switch_process("SB09", e)
                          }
                        />
                        <Switch
                          checkedChildren="停車場所明亮安全"
                          unCheckedChildren="停車場所暗黑不安全"
                          defaultChecked={SB10 === 0 ? true : false}
                          onChange={(e) =>
                            this.handle_ui_switch_process("SB10", e)
                          }
                        />
                        <Switch
                          checkedChildren="通勤上下學路線安全"
                          unCheckedChildren="通勤上下學路線不安全"
                          defaultChecked={SB11 === 0 ? true : false}
                          onChange={(e) =>
                            this.handle_ui_switch_process("SB11", e)
                          }
                          disabled={true}
                        />
                        <Divider orientation="left" plain>
                          C.宣導項目
                        </Divider>
                        <Switch
                          checkedChildren="瞭解用電安全常識"
                          unCheckedChildren="不瞭解用電安全常識"
                          defaultChecked={SC11 === 0 ? true : false}
                          onChange={(e) =>
                            this.handle_ui_switch_process("SC11", e)
                          }
                        />
                        <Switch
                          checkedChildren="熟稔住所逃生通道及逃生要領"
                          unCheckedChildren="不熟稔住所逃生通道及逃生要領"
                          defaultChecked={SC12 === 0 ? true : false}
                          onChange={(e) =>
                            this.handle_ui_switch_process("SC12", e)
                          }
                        />
                        <Switch
                          checkedChildren="知悉使用內政部最新『住宅租賃契約書』"
                          unCheckedChildren="不知使用內政部最新『住宅租賃契約書』"
                          defaultChecked={SC13 === 0 ? true : false}
                          onChange={(e) =>
                            this.handle_ui_switch_process("SC13", e)
                          }
                        />
                        <Switch
                          checkedChildren="知悉鄰近派出所、消防隊、醫療院所及學校校安專線聯繫電話"
                          unCheckedChildren="不知悉鄰近派出所、消防隊、醫療院所及學校校安專線聯繫電話"
                          defaultChecked={SC14 === 0 ? true : false}
                          onChange={(e) =>
                            this.handle_ui_switch_process("SC14", e)
                          }
                        />
                        <Divider orientation="left" plain>
                          D.申請項目
                        </Divider>
                        <Switch
                          checkedChildren="申請政府租金補貼"
                          unCheckedChildren="未申請政府租金補貼"
                          defaultChecked={SD01 === 0 ? true : false}
                          onChange={(e) =>
                            this.handle_ui_switch_process("SD01", e)
                          }
                          // disabled={true}
                        />
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
              {LiveType === "NONE" &&
              formateDate(LiveCaseReplyDateTime) === "1999-1-1 00:00:00" ? (
                <div className="form-row">
                  <input
                    type="submit"
                    value="確認"
                    className="btn btn-primary btn-sm btn-block"
                    disabled={!agreePrivacy}
                  />
                </div>
              ) : (
                <div className="form-row">
                  <input
                    type="submit"
                    value="變更"
                    className="btn btn-success btn-sm btn-block"
                    disabled={!agreePrivacy}
                  />
                </div>
              )}
            </Card>
          </TabPane>
          <TabPane tab="近期公告" key="2">
            <SearchBulletinBoard />
          </TabPane>
        </Tabs>
        {formateDate(LiveCaseReplyDateTime) === "1999-1-1 00:00:00" ? (
          <>
            <Alert message="尚未確認個人賃居資訊" type="error" />
          </>
        ) : (
          ""
        )}
      </form>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(SurveyStudent);
